import { render, staticRenderFns } from "./centralscann.vue?vue&type=template&id=b49bdae6&scoped=true&"
import script from "./centralscann.vue?vue&type=script&lang=js&"
export * from "./centralscann.vue?vue&type=script&lang=js&"
import style0 from "./centralscann.vue?vue&type=style&index=0&id=b49bdae6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49bdae6",
  null
  
)

export default component.exports